module.exports = __webpack_public_path__ + "static/media/wp_default.9d135a87.svg";